<template>
  <v-card v-if="bookCar">
    <v-card-text>
      <div class="card-car">
        <h2 class="car-name text-subtitle-2">
          <small class="mr-1">{{bookCar.maker}}</small>
          <span class="mr-1">{{bookCar.name}}</span>
        </h2>
        <v-row no-gutters align="center">
          <v-col cols="auto">
            <v-img
              :src="bookCar.images[0]"
              :width="88"
              :aspect-ratio="4/3"
              contain
            />
          </v-col>
          <v-col class="pl-4 text-caption">
            <div>{{carTypeName}}</div>
            <div class="mb-1">
              <span class="d-inline-block mr-1">{{displacementText}}</span>
              <span class="d-inline-block mr-1">{{fuelText}}</span>
              <span class="d-inline-block mr-1">/</span>
              <span class="d-inline-block mr-1">{{driveText}}</span>
              <span class="d-inline-block mr-1">/</span>
              <span class="d-inline-block mr-1">{{bookCar.seat}}人乗り</span>
            </div>
            <div>
              <span class="mr-4">料金</span>
              <span class="mr-1">{{bookCharge.basic | comma}}</span>
              <small>円</small>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.card-car {
  .rounded {
    border-radius: 3px;
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'
import * as C from '@/app/special/consts'

import { mapGetters } from 'vuex'

export default {
  name: 'CardBookCar',
  mixins: [
    PartBase
  ],
  computed: {
    ...mapGetters('book', [
      'bookCar',
      'bookCharge'
    ]),
    carTypeName () {
      const name = C.cartypeNames[this.bookCar.type]
      return name || ''
    },
    missionText () {
      const item = this.bookCar.specs.find(item => item.name === 'ギア')
      if (!item) {
        return 'AT'
      }
      return item.value
    },
    driveText () {
      const item = this.bookCar.specs.find(item => item.name === '駆動')
      if (!item) {
        return '2WD'
      }
      return item.value
    },
    fuelText () {
      const item = this.bookCar.specs.find(item => item.name === '燃料')
      if (!item) {
        return 'ガソリン'
      }
      return item.value
    },
    displacementText () {
      const item = this.bookCar.specs.find(item => item.name === '排気量')
      if (!item) {
        return '-- L'
      }
      return (item.value / 1000) + 'L'
    }
  }
}
</script>
